import type { DateValue } from 'react-aria-components/Calendar';
import {
  Calendar as RACCalendar,
  type CalendarProps as RACCalendarProps,
} from 'react-aria-components/Calendar';

import { cx } from '../../utils/cx';
import { useDateFormat } from '../date_format_context/date_format_context';
import { CalendarContent } from './calendar_content/calendar_content';

import styles from './calendar_content/calendar_content.module.css';

export type CalendarProps<T extends DateValue> = Omit<
  RACCalendarProps<T>,
  'className'
> & {
  className?: string;
};

export function Calendar<T extends DateValue>({
  className,
  firstDayOfWeek,
  ...rest
}: CalendarProps<T>) {
  const { firstDayOfWeek: contextFirstDayOfWeek } = useDateFormat();

  return (
    <RACCalendar
      {...rest}
      firstDayOfWeek={firstDayOfWeek ?? contextFirstDayOfWeek}
      className={cx([styles.calendar, className])}
    >
      <CalendarContent />
    </RACCalendar>
  );
}
